import React from 'react';
import LazyImage from '../LazyImage';
import './HomeAbout.css';
import aboutPersonImage from '../../assets/images/about-person.webp';
import aboutPersonSmallImage from '../../assets/images/about-person-sm.webp';
import aboutPersonBackImage from '../../assets/images/about-person-back.webp';
import aboutPersonBackSmallImage from '../../assets/images/about-person-back-sm.webp';
import scoreCardImage from '../../assets/images/score-card.webp';

const HomeAbout = () => {
  return (
    <section className='home-about'>
      <div className='home-about-container'>
        <div className='home-about-content'>
          <div className='home-about-left'>
            <div className='about-image-container'>
              <LazyImage
                src={aboutPersonBackImage}
                smallSrc={aboutPersonBackSmallImage}
                alt='Background layer'
                className='about-person-back'
              />
              <LazyImage
                src={aboutPersonImage}
                smallSrc={aboutPersonSmallImage}
                alt='Professional tax and accounting experts'
                className='about-person-image'
              />
              <LazyImage src={scoreCardImage} alt='Tax Health Score Card' className='score-card-image' />
            </div>
          </div>
          <div className='home-about-right'>
            <div className='about-tag'>About Us</div>
            <h2 className='about-heading'>
              Your Trusted <span className='text-primary'>Financial Advisor and Tax Experts</span>
              <br />
              <span className='text-dark'>
                Making Money Matters
                <br />
              </span>
            </h2>
            <div className='about-description'>
              <p>
                Let <strong>Mandeep</strong> and his team of <strong>experienced accounting professionals at PFGS</strong> handle your tax returns,
                financial planning, and bookkeeping — so you can focus on what matters most: running your business, managing your work, and enjoying
                life, stress-free.
              </p>
              <p>
                We pride ourselves on being easy to work with, responsive, and reliable. Whether it's filing your taxes, managing your accounts, or
                planning your finances, we ensure everything is done accurately, on time, and with your best interest in mind.
              </p>
              <p>
                And the best part? <strong>We offer exceptional service at a cost that makes sense.</strong> Our goal is to deliver real value through
                expert advice and efficient solutions that save you both time and money.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;
